import {Component, OnInit} from '@angular/core';
import {
  AuthService,
  RolService,
  TipoDocumentoService,
  UploadFileService,
  SecretariaService
} from '../../providers';
import {CustomToastrService} from '../../commons/providers/custom-toastr.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbDateParserFormatter, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder} from '@angular/forms';
import {NewEditSecretariaComponent} from './modals/new-edit-secretaria/new-edit-secretaria.component';
import {ExportAsConfig, ExportAsService} from 'ngx-export-as';
import {ModalMostrarTodoComponent} from '../../commons/modals/modal-mostrar-todo/modal-mostrar-todo.component';
import {WebStorageCustomService} from '../../commons/providers/web-custom-storage.service';

@Component({
  selector: 'app-secretaria',
  templateUrl: './secretaria.component.html',
  styleUrls: ['./secretaria.component.scss']
})
export class SecretariaComponent implements OnInit  {
  fechaInicio: any;
  fechaFin: any;
  totalItems: number = null;
  queryCount: number = null;
  itemsPerPage: number = null;
  page: number = null;
  predicate: any;
  reverse: any;
  secretarias: any;
  totalPage: number = null;
  filtroSelect: any[];
  filterInput: any = '';
  filterSecretaria: any = {
    nombre: null,
    filtro: null
  };
  showTable = false;
  cargarTodo = false;
  cantidadItems = 25;
  permisos: Array<any>;

  constructor(
    private secretariaService: SecretariaService,
    private rolService: RolService,
    private uploadService: UploadFileService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    public webStorageCustomService: WebStorageCustomService,
    private parserFormatter: NgbDateParserFormatter,
    private tipoDocumentoService: TipoDocumentoService,
    private toast: CustomToastrService,
    private router: Router,
    private authService: AuthService,
    private exportAsService: ExportAsService
  ) {

    this.itemsPerPage = this.cantidadItems;
    this.page = 1;
    this.predicate = 'id';
    // this.filtroSelect = [
    //   {
    //     nombre: 'Nombre',
    //     filtro: 'nombre'
    //   },
    //   {
    //     nombre: 'Identificación',
    //     filtro: 'identificacion'
    //   }
    //   ,
    //   {
    //     nombre: 'Fecha Creación',
    //     filtro: 'fecha'
    //   }
    // ];
  }


   ngOnInit() {


    if (this.webStorageCustomService.checkFromLocal('permisos')) {

      this.permisos = JSON.parse(this.webStorageCustomService.getFromLocal('permisos'));

    }
    this.loadAll();
  }

  async loadAll() {
    const query = {
      page: this.page - 1,
      size: this.itemsPerPage,
      sort: this.sort()
    };
    //
    // if (this.filterSecretaria !== null) {
    //
    //   if (this.filterSecretaria && this.filterSecretaria.filtro !== 'fecha' && this.filterSecretaria.filtro !== null) {
    //     query[this.filterSecretaria.filtro] = this.filterInput;
    //   } else if (this.filterSecretaria.filtro === 'fecha') {
    //     query['fechaInicio'] = this.parserFormatter.format(this.fechaInicio);
    //     query['fechaFin'] = this.parserFormatter.format(this.fechaFin);
    //   }
    //
    // }


    await this.secretariaService
      .query(query)
      .toPromise().then(
        (res: any) => {
          this.queryCount = res.numberOfElements;
          this.totalPage = res.totalPages;
          this.totalItems = res.totalElements;
          this.secretarias = res.content;

          if (res.content.length > 0) {
            this.showTable = true;
          } else {
            this.showTable = false;
          }

        },
        (err) => {
          this.showTable = false;
          this.onError(err.message);
        }
      );
  }

  sortlist(predicate: string) {
    this.predicate = predicate;
    this.reverse = !this.reverse;
    this.loadAll();
  }

  transition() {
    this.loadAll();
  }

  sort() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    return result;
  }


  public onError(errorMessage: string) {
    console.error(errorMessage, null, null);
  }

  filtrar() {
    this.loadAll();
  }

  public open(secretaria?: any, permiso?: string) {
    if (this.validatePermission(permiso)) {
      const modal: NgbModalRef = this.modalService.open(NewEditSecretariaComponent, {});
      if (secretaria) {
        secretaria.file = null;
        modal.componentInstance.secretaria = secretaria;
      }
      modal.result.then(
        (success: Object) => {
          this.loadAll();
        },
        (error: any) => {
          // console.error(error);
        }
      );
    } else {
      this.toast.showToast('error', 'No posee permisos para realizar esta accion', 'Administración de roles');
    }
  }

  deleteSecretaria(id: number) {
    if (this.validatePermission('secretarias.eliminar')) {
      this.secretariaService.delete(id).subscribe(res => {

        this.loadAll();
      });
    } else {
      this.toast.showToast('error', 'No posee permisos para realizar esta accion', 'Administración de secretarias');
    }
  }

  public validatePermission(accion: string) {

    if (this.permisos.length > 0) {

      if (this.permisos.includes('root.all') || this.permisos.includes(accion)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }


  }

  export(tipo: any) {

    const exportAsConfig: ExportAsConfig = {
      type: tipo,
      elementId: 'table',
      options: {
        orientation: 'landscape'
      }
    };
    this.exportAsService.save(exportAsConfig, 'lista_secretarias');

  }

  todo() {

    this.cargarTodo = !this.cargarTodo;

    if (this.cargarTodo) {
      this.mostrarTodoModal();
    } else {
      this.itemsPerPage = this.cantidadItems;
      this.loadAll();
    }


  }


  public mostrarTodoModal() {
    const modal: NgbModalRef = this.modalService.open(ModalMostrarTodoComponent, {size: 'sm'});
    modal.componentInstance.texto = this.totalItems;
    modal.result.then(
      (success: Object) => {
        this.itemsPerPage = this.totalItems;
        this.loadAll();
      },
      (error: any) => {
        this.cargarTodo = !this.cargarTodo;
        this.loadAll();
      }
    );

  }

}
